import { requirePermission } from "@/lib/casl/route-guards";
import { createFileRoute } from "@tanstack/react-router";
import { MentorDataDashboard } from "@/components/mentor-data-dashboard";

export const Route = createFileRoute("/_authenticated/mentor-data-dashboard")({
  component: MentorDashboard,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "analytics");
  },
});

function MentorDashboard() {
  return <MentorDataDashboard />;
}
